import {Component, Inject, Input, OnInit, SimpleChanges, ViewContainerRef} from '@angular/core';
import {Overlay} from "angular2-modal";
import {Modal} from "angular2-modal/plugins/bootstrap";
import {ActivatedRoute, Router} from "@angular/router";
import {User} from "../../shared/model/user";
import {RestaurantService} from "../../shared/services/restaurant/restaurant.service";
import {AuthService} from "../../shared/security/auth.service";
import {UserService} from "../../shared/services/user/user.service";
import {Code} from "../../shared/model/code";
import {FormGroup, FormBuilder, Validators} from "@angular/forms";
import {validateEmail} from "../../shared/validators/validate-email";
import {DOCUMENT} from "@angular/platform-browser";

@Component({
  selector: 'app-user-register',
  templateUrl: './user-register.component.html',
  styleUrls: ['./user-register.component.css']
})
export class UserRegisterComponent implements OnInit {
  roles: string[] = ['Admin - Bill Pay','Admin','Monitor'];

  user:User;
  codeRecord:Code;
  form:FormGroup;

  @Input()
  initialValues:any;
   currentRestaurantName:string;
  private restaurantId:string;
  private selectedRole:string;
  private selectorIsClicked:boolean;
  private myPath:string;
  private code:string;
  private isCreating:boolean;
  private isEditing:boolean;
  private isRegistering:boolean;
  private existingUser:boolean;
   first:string;
   last:string;
   userEmail:string;
   codeUsed:boolean;
  private currentUserId:string;
   userIsOnTheSystemAndRestaurant:boolean = false;
   userOnSystemNotOnRestaurant:boolean = false;
   userOnSystem:boolean = false;
  private roleToSave:string;
  private ownerName:string;

  constructor(
    public modal:Modal,
    private formBuilder: FormBuilder,
    private router:Router,
    private route:ActivatedRoute,
    private authService: AuthService,
    private userservice:UserService,
    overlay: Overlay,
    vcRef: ViewContainerRef,
    @Inject(DOCUMENT) private document,
  ) {

    this.form = this.formBuilder.group({
      firstName:['',[Validators.required,Validators.minLength(2)]],
      lastName:['',[Validators.required,Validators.minLength(2)]],
      email:['',[Validators.required, validateEmail]],
      password:['',[Validators.required,Validators.minLength(8)]],
      confirm:['',Validators.required],
      nickName:['',Validators.required],
      agreed:[false, Validators.pattern('true')]

    });

    this.selectorIsClicked = false;

    overlay.defaultViewContainer = vcRef;


    this.user = Object.assign({});


    // console.log("User Register Componenet Constructor!")

  }


  initialiseForm(){


    let myRandom = Math.random() * (2 - 50) + 1;
    myRandom = Math.round(myRandom);

    this.form.controls['agreed'].setValue( true);
    this.form.controls['firstName'].setValue( myRandom+"Barbara");
    this.form.controls['lastName'].setValue( myRandom+"Pierce");
    // this.form.controls['email'].setValue( "bbr"+myRandom+"@luissalcedo.com");
    this.form.controls['password'].setValue( "password");
    this.form.controls['confirm'].setValue( "password");
    this.form.controls['nickName'].setValue( myRandom+"mg");

  }



  ngOnInit() {

    // this.initialiseForm();

    let myRoute = this.route.snapshot;

    this.myPath = myRoute.url[0].path;


    this.isCreating = false;
    this.isEditing = false;
    this.isRegistering = false;

    switch(this.myPath) {
      case "create": {
        this.isCreating = true;
        break;
      }
      case "register": {
        this.isRegistering = true;
        break;
      }
      case "edit": {
        this.isEditing = true;
        break;
      }
      default: {
        this.messageIt("Error on registration", "Please contact your system adminstrator ");
        break;
      }
    }


    if (this.isRegistering) {

      this.code = myRoute.params['code'];
      this.restaurantId = myRoute['id'];


      const singAnonym$ = this.authService.anonymously();
      singAnonym$
        .subscribe((res) => {
          const codeRecord$ = this.userservice.getRegCodeRecord(this.code)
          codeRecord$
            .subscribe(theRecord => {
              this.codeRecord = theRecord;
              this.existingUser = this.codeRecord.userInRecord;
              this.restaurantId = this.codeRecord.restaurantId;
              this.form.controls['email'].setValue(this.codeRecord.userEmail);
              this.currentRestaurantName = this.codeRecord.restaurant;
              this.roleToSave = this.roleToSave = this.userservice.roleSave(this.codeRecord.userRole);
            if (this.codeRecord.usedDateTime != "") {
                this.codeUsed = true;
              }
              const user$ = this.userservice.getUserByEmail(this.codeRecord.userEmail)
              user$
                .subscribe((theUser) => {
                  this.user = theUser;
                  this.first = this.user.first;
                  this.last = this.user.last;
                  this.userEmail = this.user.email;
                  this.currentUserId = this.user.$key;
                  this.userOnSystemNotOnRestaurant = true;
                  this.userOnSystem = true;
                  const userOnRestaurant$ = this.userservice.isUserOnRestaurant(this.restaurantId,this.user.$key)
                  userOnRestaurant$
                    .subscribe((result)=>{
                      if (result.length > 0){
                        this.userIsOnTheSystemAndRestaurant = true;
                        this.userOnSystemNotOnRestaurant = false;
                      }
                    })
                })
            });

        })

    }

  }





  /*
   const relation = this.userservice.getUserRole(this.restaurantId,this.userId);
   relation
   .subscribe((thisRelations) => {
   this.selectedRole = thisRelations;
   this.select(this.selectedRole);


   this.logedInSysID = this.authService.getUid();

   const logedUser$ = this.userservice.getUser(this.logedInSysID);
   logedUser$
   .subscribe((user)=>{
   this.logedUserId = user.$key;
   const logRelation = this.userservice.getUserRole(this.restaurantId,this.logedUserId);
   logRelation
   .subscribe((logedRelation)=>{
   this.logedRole = logedRelation;
   this.adminDbAdmin = this.selectedRole == 'admin-db';
   });
   })
   });
   */




  register(form){

    if (this.userIsOnTheSystemAndRestaurant || this.userOnSystemNotOnRestaurant) {
      this.existingUser = true;
    }


    if (!this.userOnSystem){

      const isValid = this.form.valid;

      if (isValid) {

        this.user.first = this.form.value.firstName;
        this.user.last = this.form.value.lastName;
        this.user.nickName = this.form.value.firstName;
        this.user.isActive = true;
        this.user.email = this.form.value.email;
        this.ownerName = this.form.value.firstName + " " + this.form.value.lastName;

        this.createUser();
      } else {

        form.showErrors();

      }

    } else {

      this.codeRecord.usedDateTime = new Date().toISOString();
      this.codeRecord.userId = this.user.$key;
      if(this.existingUser){
        this.createUserRestaurant();
      }
      this.navigateOut()

    }

  }




  private createUser() {
    const newAuthUser$ = this.authService.createUser(this.user.email ,this.form.value.password,this.ownerName);
    newAuthUser$
      .subscribe((user) => {
        this.existingUser = true;
        this.user.sysUid = user.uid;
        this.authService.sendVerificationEmmail().subscribe();
        this.authService.updateProfileName(this.ownerName).subscribe();
        const newUser$ = this.userservice.createUser(this.user);
        newUser$
          .subscribe(
            (user)=>
            {
              const getUserKey$ = this.userservice.getUser(this.user.sysUid);
              getUserKey$
                .subscribe((user) => {
                  const usersRest$ = this.userservice.createUserRestaurant(user.$key,user.email,this.restaurantId,this.roleToSave);
                  usersRest$
                    .subscribe((userRestaurant)=>{
                      this.codeRecord.usedDateTime = new Date().toISOString();
                      this.codeRecord.userId = this.user.$key;
                      this.codeRecord.userInRecord = true;
                      if(this.existingUser){
                        this.markCodeUsed();
                      }
                      this.navigateOut()
                    })
                })
            })
      });
  }


  private createUserRestaurant(){
    const userRestaurant$ = this.userservice.createUserRestaurant(this.user.$key,this.user.email,this.codeRecord.restaurantId,this.userservice.roleSave(this.codeRecord.userRole));
    userRestaurant$
      .subscribe(()=>{
        this.markCodeUsed();
      })

  }

  private markCodeUsed(){
    const markCodeAsUsed$ = this.userservice.markCodeAsUsed(this.codeRecord);
    markCodeAsUsed$
      .subscribe((thisCodeRecord)=>
        {
        }
      )

  }


  navigateOut(){
      this.authService.logout();
      this.router.navigate(['/download'])
  }





  ngOnChanges(changes:SimpleChanges){

    if (this.form && changes['initialValues']){
      this.form.patchValue(changes['initialValues'].currentValue);

    }

  }

  showErrors(){

    for (let element in this.form.controls){
      for(let element1 in  this.form.controls[element].errors){
        this.form.controls[element].markAsDirty();
      }
    }
    if (this.selectedRole === "Select a role"){
      this.selectorIsClicked = true;
      this.form.controls['role'].markAsDirty();
    }

  }

  printOpening() {

    this.selectorIsClicked = true;
  }

  printClosing() {


    this.selectorIsClicked = true;
  }

  clicked(){

  }


  select(selectedRole:string) {

    this.selectedRole = selectedRole;
    this.form.controls['role'].setValue(selectedRole);

  }

  itHaveErrors(){

    const isValid = this.form.valid;

    return isValid;

  }


  showSelectorError(){
    const showError = this.selectedRole == "Select a role" && this.selectorIsClicked;

    return showError;
  }

  isErrorVisible(field:string,error:string){

    return this.form.controls[field].dirty && this.form.controls[field].errors && this.form.controls[field].errors[error];

  }

  reset() {
    this.form.reset();
  }

  get valid(){
    return this.form.valid;
  }

  get value(){
    return this.form.value;
  }


  setBlank(){

    this.form.reset();
    this.selectedRole = this.initialValues.role;
    this.selectorIsClicked = false;
  }

  itMatch(){
    const val = this.form.value;
    const itMatch = val.password == val.confirm;
    return itMatch;
  }


  messageIt(titleP: string, messageP: string) {

    this.modal.alert()
      .size('lg')
      .showClose(true)
      .title(titleP)
      .body(messageP)
      .open();
  }


  cancel() {
    this.router.navigate(['/home'])
  }


  login(){
      this.router.navigate(['/login'])
  }







  openTerms(){

    this.messageIt('Terms of Service ("Terms")',
      `
    <p>Last updated: December 27, 2016</p>
    <p>Please read these Terms of Service ("Terms", "Terms of Service") carefully before using the SRVPLS website (the "Service") operated by SRVPLS ("us", "we", or "our").</p>
    <p>Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms. These Terms apply to all visitors, users and others who access or use the Service.</p>
    <p>By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part of the terms then you may not access the Service.

        <p><strong>Accounts</strong></p>
        <p>When you create an account with us, you must provide us information that is accurate, complete, and current at all times. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account on our Service.</p>
        <p>You are responsible for safeguarding the password that you use to access the Service and for any activities or actions under your password, whether your password is with our Service or a third-party service.</p>
        <p>You agree not to disclose your password to any third party. You must notify us immediately upon becoming aware of any breach of security or unauthorized use of your account.</p>
        <p><strong>Links To Other Web Sites</strong></p>
        <p>Our Service may contain links to third-party web sites or services that are not owned or controlled by SRVPLS.</p>
        <p>SRVPLS has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third party web sites or services. You further acknowledge and agree that SRVPLS shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such content, goods or services available on or through any such web sites or services.</p>
        <p>We strongly advise you to read the terms and conditions and privacy policies of any third-party web sites or services that you visit.</p>
        <p><strong>Termination</strong></p>
        <p>We may terminate or suspend access to our Service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.</p>
        <p>All provisions of the Terms which by their nature should survive termination shall survive termination, including, without limitation, ownership provisions, warranty disclaimers, indemnity and limitations of liability.</p>
        <p>We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.</p>
        <p>Upon termination, your right to use the Service will immediately cease. If you wish to terminate your account, you may simply discontinue using the Service.</p>
        <p>All provisions of the Terms which by their nature should survive termination shall survive termination, including, without limitation, ownership provisions, warranty disclaimers, indemnity and limitations of liability.</p>
        <p><strong>Governing Law</strong></p>
        <p>These Terms shall be governed and construed in accordance with the laws of Florida, United States, without regard to its conflict of law provisions.</p>
        <p>Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will remain in effect. These Terms constitute the entire agreement between us regarding our Service, and supersede and replace any prior agreements we might have between us regarding the Service.</p>
        <p><strong>Changes</strong></p>
        <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material we will try to provide at least 30 days notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.</p>
        <p>By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, please stop using the Service.</p>
        <p><strong>Contact Us</strong></p>
        <p>If you have any questions about these Terms, please contact us.</p>
  
      `
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/user/user-register/user-register.component.ts